import React from "react";
import AnimatedSvgGroup from "../../animatedSvgBits/AnimatedGroup";
import AnimatedSvgThing from "../../animatedSvgBits/AnimatedSvgThing";

export default function Pickup({ timings, progress, isTransparent }) {
  const outlineColour = "rgba(0,0,0,0.4)";
  const strokeWidth = 0.4;

  return (
    <g
      strokeDasharray="none"
      strokeLinejoin="round"
      strokeMiterlimit="4"
      strokeWidth="0.529"
      color="#000"
      paintOrder="markers fill stroke"
    >
      <AnimatedSvgThing
        className={`tapeComponent ${isTransparent && "transparent"}`}
        type="path"
        timings={timings}
        progress={progress}
        fill="#111119"
        strokeWidth={strokeWidth}
        stroke={outlineColour}
        d="M95.096 138.038h38.608c1.077 0 1.944.927 1.944 2.078v11.32c0 1.152-.394 1.96-1.85 2.716l-6.389 3.596h-26.118l-6.218-4.174c-.895-.6-1.92-.986-1.92-2.137v-11.321c0-1.151.866-2.078 1.943-2.078z"
      />
      <g
        fillRule="evenodd"
        strokeLinecap="round"
        transform="translate(-1.173 -1.04)"
      >
        <AnimatedSvgGroup
          className={`tapeComponent ${isTransparent && "transparent"}`}
          timings={timings}
          progress={progress}
          fill="#ccc"
          stroke="none"
          aria-label="SPOOLZ"
        >
          <path d="M107.501 147.698q0 .24-.113.474-.11.234-.311.397-.22.176-.516.275-.292.1-.705.1-.444 0-.8-.083-.352-.083-.719-.245v-.684h.039q.311.26.72.4.407.14.765.14.507 0 .788-.19.284-.19.284-.507 0-.273-.135-.402-.132-.13-.405-.202-.207-.055-.449-.09-.24-.036-.51-.092-.546-.115-.81-.394-.262-.28-.262-.73 0-.515.435-.843.436-.331 1.106-.331.432 0 .793.083.361.082.64.204v.644h-.039q-.234-.198-.617-.328-.38-.132-.78-.132-.438 0-.706.182-.264.182-.264.469 0 .256.132.402.132.146.466.223.176.039.501.094.326.055.552.113.457.121.689.367.231.245.231.686z" />
          <path d="M111.062 146.006q0 .272-.096.507-.094.231-.265.402-.212.212-.502.32-.29.104-.73.104h-.546v1.53h-.545v-4.104h1.113q.37 0 .626.064.256.06.454.193.235.157.361.391.13.234.13.593zm-.568.013q0-.212-.074-.369-.075-.157-.226-.256-.132-.086-.303-.122-.168-.038-.428-.038h-.54v1.64h.46q.331 0 .538-.058.207-.06.336-.19.13-.133.182-.279.055-.146.055-.328z" />
          <path d="M114.843 145.237q.251.275.383.675.135.4.135.907t-.137.91q-.135.399-.38.666-.254.278-.602.419-.344.14-.788.14-.432 0-.788-.143-.353-.143-.6-.416-.249-.273-.384-.67-.132-.397-.132-.906 0-.502.132-.899.132-.4.386-.683.242-.27.6-.414.362-.143.786-.143.441 0 .791.146.353.143.598.41zm-.05 1.582q0-.8-.358-1.232-.358-.436-.978-.436-.626 0-.984.436-.355.432-.355 1.232 0 .807.363 1.237.364.427.976.427t.973-.427q.364-.43.364-1.237z" />
          <path d="M119.286 145.237q.25.275.383.675.135.4.135.907t-.138.91q-.135.399-.38.666-.253.278-.6.419-.345.14-.789.14-.433 0-.788-.143-.353-.143-.601-.416t-.383-.67q-.132-.397-.132-.906 0-.502.132-.899.132-.4.386-.683.242-.27.6-.414.362-.143.786-.143.441 0 .791.146.353.143.598.41zm-.05 1.582q0-.8-.358-1.232-.358-.436-.978-.436-.626 0-.984.436-.356.432-.356 1.232 0 .807.364 1.237.364.427.976.427t.973-.427q.363-.43.363-1.237z" />
          <path d="M123.266 148.87h-2.596v-4.105h.545v3.62h2.05z" />
          <path d="M126.81 148.87h-3.202v-.508l2.516-3.112H123.7v-.485h3.049v.494l-2.542 3.125h2.602z" />
        </AnimatedSvgGroup>

        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="none"
          stroke="#ccc"
          d="M102.077 142.474h26.994v8.686h-26.994z"
        />
      </g>
      <AnimatedSvgThing
        className={`tapeComponent ${isTransparent && "transparent"}`}
        type="path"
        timings={timings}
        progress={progress}
        fill="none"
        fillRule="evenodd"
        stroke="#ccc"
        strokeLinecap="round"
        strokeOpacity="1"
        d="M106.373 152.076h15.502"
      />
      <AnimatedSvgThing
        className={`tapeComponent ${isTransparent && "transparent"}`}
        type="path"
        timings={timings}
        progress={progress}
        fill="none"
        fillRule="evenodd"
        stroke="#ccc"
        strokeLinecap="round"
        strokeOpacity="1"
        d="M109.087 153.664h10.074"
      />
    </g>
  );
}
